<template>
	<div class="container page">
		<van-nav-bar :title="videoInfo.vod_name || $t('video.video')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back" />
			</template>
		</van-nav-bar>
		<div class="movie-video">
			<video id="my-video" class="video-js" ref="videoPlayer"></video>
		</div>
		<div class="movie-content">
			<div class="movie-descript">
				<p>{{ videoInfo.vod_name }}</p>
				<span>{{ videoInfo.count }}{{ $t("video.num_play") }}</span>
			</div>
			<!-- <div class="movie-body">
				<div class="movie-title">
					<div>
						<span>{{ $t("index.recmonmand") }}</span>
					</div>
				</div>
			</div> -->
			<!-- <div class="hotlist">
				<div v-for="(v, key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
					<img :src="v.vod_pic" />
					<div>
						<span>{{ v.vod_name }}</span><span>{{ $t("video.play") }}:{{ v.count }}</span>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import videojs from "video.js";
	import "videojs-contrib-hls";

	export default {
		data() {
			return {
				nowPlayVideoUrl: "",
				cover: "",
				userInfo: [],
				videoInfo: {},
				moreVideoInfo: [],
				player: null,
				isPlaying: false,
				isMember: true, // 假设初始为会员，实际应根据用户信息判断
				videoPlayCheckInterval: null,
			};
		},
		methods: {
			// 返回上一页
			back() {
				this.$router.push({
					path: "/Video"
				});
			},
			// 获取视频信息
			getVideoInfo() {
				this.$http({
					method: "get",
					data: {
						id: this.$route.query.id
					},
					url: "video_get_info",
				}).then((res) => {
					this.videoInfo = res.data;
					this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
					this.cover = this.videoInfo.vod_pic;
					this.initializePlayer();
				});
			},
			// 初始化播放器
			initializePlayer() {
				this.player = videojs(this.$refs.videoPlayer, {
					height: "200px",
					preload: "auto",
					controls: true,
				});

				// 监听播放事件
				this.player.on("play", () => {
					this.isPlaying = true;
					// 开始检查播放时间
					this.startVideoPlayCheck();
				});

				// 设置封面图
				this.player.poster(this.cover);

				// 设置视频源
				const cleanUrl = (this.nowPlayVideoUrl || '').split('?')[0].toLowerCase();
				const videoType = cleanUrl.endsWith('.m3u8')
					? 'application/x-mpegURL'
					: (cleanUrl.endsWith('.webm') ? 'video/webm' : 'video/mp4');
				this.player.src([{
					src: this.nowPlayVideoUrl,
					type: videoType,
				}]);
			},
			// 开始视频播放检查
			startVideoPlayCheck() {
				// 清除之前的检查间隔
				clearInterval(this.videoPlayCheckInterval);
				// 设置新的检查间隔
				this.videoPlayCheckInterval = setInterval(() => {
					if (this.isPlaying) {
						const currentTime = Math.round(this.player.currentTime());
						if (currentTime >= 30) { // 播放时间达到30秒
							this.checkUserMembership();
						}
					}
				}, 1000);
			},
			// 检查用户是否为会员
			checkUserMembership() {
				// 此处应为实际检查用户是否为会员的逻辑
				// 假设我们通过调用某个API获取用户信息
				this.$http({
					method: "get",
					url: "user_info",
				}).then((res) => {
					if (res.code === 200) {
						this.userInfo1 = res.data;
						if(Number(this.userInfo1.money) > 0){
							console.log(Number(this.userInfo1.money));
						}else{
							this.isPlaying = false;
							this.player.pause();
							this.$toast(this.$t("video.username_place1"));
							// 禁止视频再次播放
							this.player.on("play", () => {
								this.player.pause();
								this.$toast(this.$t("video.username_place1"));
							});
						}
						// 是会员，不做处理
					} 
				});
			},
			// 跳转到其他视频播放页面
			toPlayVideo(id) {
				if (!localStorage.getItem("token")) {
					this.$router.push({
						path: "/Login"
					});
				} else {
					this.$router.push({
						path: `/Video?id=${id}`
					});
				}
			},
			// 获取更多视频推荐
			getMoreVideoItem() {
				this.$http({
					method: "get",
					url: "video_get_more_item",
				}).then((res) => {
					this.moreVideoInfo = res.data;
				});
			},
			// 获取用户信息
			getUserInfo() {
				this.$http({
					method: "get",
					url: "user_info",
				}).then((res) => {
					if (res.code === 200) {
						this.userInfo = res.data;
						if (this.userInfo.status !== 1) {
							this.$toast(this.$t("video.account_out"));
							localStorage.clear();
							this.$router.push({
								path: "/Login"
							});
						} else {
							this.getVideoInfo();
							this.getMoreVideoItem();
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
		mounted() {
			if (!localStorage.getItem("token")) {
				this.$router.push({
					path: "/Login"
				});
			} else {
				this.getUserInfo();
			}
		},
		beforeDestroy() {
			if (this.player) {
				this.player.dispose();
				this.player = null;
			}
			clearInterval(this.videoPlayCheckInterval);
		},
	};
</script>

<style scoped>
	.video-js {
		width: 100%;
		/*height: 420px;*/
		font-size: 24px;
	}

	.movie-content {
		flex: 1;
		overflow-y: auto;
	}

	.movie-content .movie-descript {
		width: 100%;
		/* height: 140px; */
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		padding: 15px;
	}

	.movie-content .movie-descript p {
		font-size: 30px;
		font-weight: 700;
		color: rgb(62, 33, 134);
	}

	.movie-content .movie-descript span {
		color: rgb(170, 45, 220);
		font-size: 0.8rem;
		background: rgb(242, 242, 245);
		padding: 10px;
		border-radius: 16px;
	}

	.movie-content .movie-body {
		width: calc(100% - 20px);
		margin: 0 auto;
	}

	::v-deep .movie-video .video-js .vjs-big-play-button {
		top: 50%;
		left: 50%;
		margin-top: -50px;
		margin-left: -100px;
	}

	.movie-content .movie-body .movie-title {
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie-content .movie-body .movie-title>div:first-child {
		width: 410px;
	}

	.movie-content .movie-body .movie-title>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 30px;
		font-weight: 700;
		color: #000;
	}

	.movie-content .movie-body .movie-title>div:first-child span:before {
		content: "";
		display: block;
		width: 8px;
		height: 30px;
		background-color: #7e5678;
		border-radius: 25px;
		margin-right: 10px;
	}

	abbr,
	address,
	article,
	aside,
	audio,
	b,
	blockquote,
	body,
	canvas,
	caption,
	cite,
	code,
	dd,
	del,
	details,
	dfn,
	div,
	dl,
	dt,
	em,
	fieldset,
	figcaption,
	figure,
	footer,
	form,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	header,
	hgroup,
	html,
	i,
	iframe,
	img,
	ins,
	kbd,
	label,
	legend,
	li,
	mark,
	menu,
	nav,
	object,
	ol,
	p,
	pre,
	q,
	samp,
	section,
	small,
	span,
	strong,
	sub,
	summary,
	sup,
	table,
	tbody,
	td,
	tfoot,
	th,
	thead,
	time,
	tr,
	ul,
	var,
	video {
		margin: 0;
		padding: 0;
		border: 0;
		outline: 0;
		font-size: 100%;
		vertical-align: baseline;
		box-sizing: border-box;
	}

	.vjs-big-play-button .vjs-icon-placeholder {
		font-size: 1.63em !important;
	}

	.hotlist {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.hotlist div {
		position: relative;
		width: calc(50% - 10px);
		border-radius: 16px;
		overflow: hidden;
		margin-bottom: 20px;
	}

	.hotlist div img {
		width: 100%;
		height: 27vw;
	}

	.hotlist div div {
		position: absolute;
		bottom: 20px;
		width: 100%;
		left: 0;
		background: rgba(0, 0, 0, .4);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 3vw;
		height: 8vw;
		border-radius: 16px;
	}

	.hotlist div div span {
		width: 50%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
		padding-left: 20px;
	}
</style>
